import type { FC } from 'react';
import type { TPlacementHostCompany } from '@shared/types/placement-host-company';
import { cn } from '@src/design-system/helpers';
import HostItem from './components/host-item';

const ContactInformation: FC<{
  host: TPlacementHostCompany;
  modal?: boolean;
}> = ({ host, modal = true }) => {
  return (
    <div
      className={cn(
        'space-y-4 p-4 m-4 mt-0 bg-white rounded-xl',
        !modal && 'm-0 p-0'
      )}
    >
      <p className='font-semibold text-gray-800'>Contact Information</p>
      <div
        className={cn(
          'grid gap-3',
          modal ? 'grid-cols-1' : 'sm:grid-cols-2 lg:grid-cols-3'
        )}
      >
        <HostItem
          label='Contact Name'
          value={host?.contact_name ?? '—'}
        />
        <HostItem
          label='Job Title'
          value={host?.contact_job_title ?? '—'}
        />
        <HostItem label='Email' value={host?.contact_email ?? '—'} />
        <HostItem
          label='Phone Number'
          value={host?.contact_phone_number ?? '—'}
        />
      </div>
    </div>
  );
};

export default ContactInformation;
